import { ref } from 'vue';

/**
 * テキストエリアのEnterキー制御を提供するcomposable
 * - IME変換中のEnterは無視し、確定後のEnterで送信処理を実行
 *
 * @param submitCallback - Enter 確定時に実行する関数
 */
export function useEnterKeyHandler({
  sendCallback,
}: {
  sendCallback: () => void;
}) {
  const isComposing = ref<boolean>(false); // IMEなどのテキスト変換システムが変換中かどうか
  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter' && !event.shiftKey && !isComposing.value) {
      event.preventDefault(); // 改行させないためにデフォルトのEnterキーの動作を防ぐ
      sendCallback();
    }
  };

  const handleCompositionStart = () => {
    isComposing.value = true;
  };

  const handleCompositionEnd = () => {
    isComposing.value = false;
  };

  return { handleKeyDown, handleCompositionStart, handleCompositionEnd };
}
